import { render, staticRenderFns } from "./PaymentMethodsSelect.vue?vue&type=template&id=4deaa7ad&"
import script from "./PaymentMethodsSelect.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodsSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports